import { Table, Tag } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import React from 'react';
import { formatDate } from 'utils';

function RolesTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  onRowClick,
  onChange,
}) {
  const columns = [
    {
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Код',
      dataIndex: 'slug',
      key: 'slug',
    },
    {
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Дата создания',
      dataIndex: 'created',
      key: 'created',
      render: (date) => formatDate(date),
    },
    {
      title: 'Статус',
      dataIndex: 'active',
      key: 'active',
      render: (isActive) => (
        <Tag color={isActive ? 'green' : ''}>
          {isActive ? 'Активный' : 'Не активный'}
        </Tag>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
      }}
      tableLayout="fixed"
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { RolesTable };
